import React, { useState, useEffect} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import './Checkout.css';
import { checkoutRequest, getPrice, phonepeCheckoutRequest, razorpayCheckoutRequest, paypalCreateOrder, paypalCaptureOrder } from '../../actions/paymentAction';
import Loader from '../../layout/Loder';
import {toast} from 'react-toastify';

const PAYPAL_CLIENT_ID = 'AcG8nflgS3n2HfX8n6-SDhZlJQS4RkWXILKaygXfrpk4mGiW2XxqU1tMk7ams_kaTUlbirFHouGRyuLY';

const Checkout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [totalTokens, setTotalTokens] = useState(1);
  const [price, setprice] = useState();
  const [loading, setloading] = useState(true);
  const [btnloading, setbtnloading] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState('razorpay');

  const fetchPrice = async () => {
    try {
      const fetchprice = await dispatch(getPrice());
      if (fetchprice !== undefined && fetchprice !== null) {
        setprice(fetchprice);
        setloading(false);
      } else {
        navigate('/error');
      }
    } catch (error) {
      toast.error(error);
    }
  };

  useEffect(() => {
    if (!document.querySelector('script[src="https://checkout.razorpay.com/v1/checkout.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      document.body.appendChild(script);
    }
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tokenValue = parseInt(searchParams.get('tokens')) || 1;
    setTotalTokens(tokenValue);
    fetchPrice();
  }, [location]);

  const handleRazorpay = async () => {
    setbtnloading(true);
    try {
      const order = { quantity: totalTokens, userId: user._id, name: user.name };
      await dispatch(razorpayCheckoutRequest(order, user));
    } catch (error) {
      toast.error('Payment failed. Please try again.');
    } finally {
      setbtnloading(false);
    }
  };

  const handlePaypalCreate = async () => {
    try {
      return await dispatch(paypalCreateOrder(totalTokens));
    } catch (error) {
      toast.error('Could not create PayPal order.');
    }
  };

  const handlePaypalApprove = async (data) => {
    try {
      await dispatch(paypalCaptureOrder(data.orderID));
      toast.success('Payment successful! D-credits added.');
      navigate('/checkout-success');
    } catch (error) {
      toast.error('PayPal capture failed. Contact support.');
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="checkout-container row">
          <div className="payment-methods col-lg-8">
            <h1>DMYOR</h1>
            <table className="user-table">
              <tbody>
                <tr><td><strong>Name:</strong></td><td>{user.name}</td></tr>
                <tr><td><strong>Email:</strong></td><td>{user.email}</td></tr>
              </tbody>
            </table>
            <h3>Payment</h3>
            <p>All payments are secured and encrypted.</p>

            <div className="payment-options">
              {/* Razorpay */}
              <div className="option">
                <div className="radio-container">
                  <input
                    type="radio" value="razorpay"
                    checked={selectedMethod === 'razorpay'}
                    onChange={() => setSelectedMethod('razorpay')}
                  />
                  <label>Razorpay (UPI / Cards / NetBanking)</label>
                </div>
                {selectedMethod === 'razorpay' && (
                  <div className="payment-info-container">
                    <p className="payment-info">You will be redirected to Razorpay to complete your purchase securely.</p>
                  </div>
                )}
              </div>

              {/* PayPal */}
              <div className="option">
                <div className="radio-container">
                  <input
                    type="radio" value="paypal"
                    checked={selectedMethod === 'paypal'}
                    onChange={() => setSelectedMethod('paypal')}
                  />
                  <label>PayPal (Cards / PayPal Balance)</label>
                </div>
                {selectedMethod === 'paypal' && (
                  <div className="payment-info-container paypal-btn-wrap">
                    <PayPalScriptProvider options={{ 'client-id': PAYPAL_CLIENT_ID, currency: 'USD' }}>
                      <PayPalButtons
                        style={{ layout: 'vertical', color: 'gold', shape: 'rect', label: 'pay' }}
                        createOrder={handlePaypalCreate}
                        onApprove={handlePaypalApprove}
                        onError={() => toast.error('PayPal encountered an error.')}
                      />
                    </PayPalScriptProvider>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="checkout-form col-lg-4">
            <div className="price-line">
              <p>Total D-credits:</p>
              <p>{totalTokens}</p>
            </div>
            <div className="price-line">
              <p className="totalamount">Total Amount: {totalTokens} x Rs.{price}:</p>
              <p className="price">Rs.{totalTokens * price}</p>
            </div>

            {selectedMethod === 'razorpay' && (
              btnloading ? (
                <button className="pay-btn btn-loading" />
              ) : (
                <button className="pay-btn" onClick={handleRazorpay}>Pay</button>
              )
            )}

            {selectedMethod === 'paypal' && (
              <p className="payment-info" style={{ marginTop: 12, fontSize: '0.82rem', opacity: 0.6 }}>
                Use the PayPal button above to complete your order.
              </p>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default Checkout;
